const requestUrl = {
	// baseUrl:'http://localhost:777/public/'
	baseUrl:'https://www.yyvvi.com'
}

export {
	requestUrl
}
  